import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
    position: relative;
    z-index: 1;
    margin-bottom: 3.375rem;
    color: #232323;
    h4
    {
    margin-bottom: 16px;
    font-size: 32px;
    line-height: 40px;
    }
`

const ModalHeader = (props) => (
    <Wrap>
        <h4>{props.headline}</h4>
        <p>{props.subline}</p>
    </Wrap>
)

export default ModalHeader



// WEBPACK FOOTER //
// ./src/components/Modal/ModalHeader.js